module.exports = __webpack_public_path__ + "static/media/joe-gardner-2.34203ce3.jpg";